import Input from "@/components/atoms/FormComponents/Input/Input";
import styles from "./HomeConnectModalForm.module.scss"
import { useCallback, useEffect, useRef, useState } from "react";
import cn from "clsx";
import { SELECT_DEGREE, SELECT_PROGRAM, connectCounsellorApiCall, degreeOptions, errorAccordingToFieldName, excludeProgramsOutsideIndia, filterSelectedPrograms, getProgramId, leadSquareApiCall, precedentSelectedPrograms, programsOptions, regexForInputs } from "./utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { fetchIpInfoFunNew, getGlobalStateValue, ALL_COUNTRIES } from "@/context/utils";
import { COUNTRY_CALLING_CODES } from "@/helpers/constants";
import SubmitButton from "@/components/atoms/FormComponents/SubmitButton";
import { useOTPContext } from "@/components/sections/CommonModals/context";
import Checkbox from "@/components/atoms/FormComponents/Checkbox";
import { trackingDetails } from "@/api/getOtherFormDetails";
import SelectDark from "@/revamp/atoms/FormComponents/Select/SelectDark";
import { PROGRAM_DROPDOWN, DEGREE_TYPES } from "@/components/molecules/ProgramMenu/constants";
import ApplicationFormRedirectLoader from "@/components/molecules/ApplicationFormRedirectLoader/ApplicationFormRedirectLoader";
import ConsentFormPara from "@/components/common/utils/consentFormPara";
import { formatDate, generateUniqueId } from "@/components/molecules/Forms/ConnectModalForm/utils";
import CountryDropdownGlobal from "@/components/atoms/FormComponents/CustomDropdownGlobal/CustomDropdownGlobal";

const NATIONAL_CODE = "+91";
const CODE = "Code";

const HomeConnectModalForm = (props: {
	setMessage?: any
	isOtpValidated ?: (x:any, y?:any) => void
	setFormResponse?: (x: any) => void
	gaOtherPayloadInfo?: any
	setFormValuesData?:(x: any) => void
	isLandingPage?: boolean,
	associatedPrograms?: Array<ProgramDetails> ,
	isNewLeadForm?: boolean,
	checkLeadFail?: (x:boolean) => void,
	isLambdaAPI?: boolean
}) => { 
    const {
        setMessage=()=> {},
        isOtpValidated = () => {},
        setFormValuesData = () => {},
        gaOtherPayloadInfo = {},
        isLandingPage = false,
        associatedPrograms = [],
        isNewLeadForm = true,
        checkLeadFail = ()=>{ },
        isLambdaAPI = false
    } = props;
	const {handleSendOTP, isOTPLoading, setLeadResponse, setIsHeaderHidden, setShowLoader } = useOTPContext()
	const specializationKey = useRef<string>('');
	const custom10PageTypeKey = useRef<string>('');
	const prospectIdRef = useRef(null);
	const [programsList, setProgramsList] = useState(programsOptions)
	const [ipStackDetails, setIpStackDetails] = useState(null);
	const [isLoading, loading] = useState(false)
	const [isFormValid, setIsFormValid] = useState(false)
	const [showProgramField, setshowProgramField] = useState(false);
    const [isApplicationLoader, setIsApplicationLoader] = useState(false);
    const [loadingCount, setLoadingCount] = useState(3);
    const counterInterval = useRef(null);
    const apiResponseURL = useRef(null);
    const [formValues, setFormValues] = useState({
		fullName: "",
		countryCode: NATIONAL_CODE,
		phoneNumber: "",
		emailId: "",
		degree: SELECT_DEGREE,
		program: "Select Program",
		isTermsAccepted: true,
	})
    const [errors, setErrors] = useState({
		fullName: "",
		countryCode: "",
		phoneNumber: "",
		emailId: "",
		degree: "",
		program: "",
		isTermsAccepted: "",
	})
	const isNational = formValues.countryCode === NATIONAL_CODE

    const handlePhoneNumberChange = (
		value: string,
		countryCodeVal: string = formValues.countryCode
	) => {
		let regexToUse = regexForInputs["phoneNumber"]
		if (countryCodeVal != NATIONAL_CODE) {
			regexToUse = /^[1-9][0-9]{6,14}$/
		}
		if (!regexToUse.test(value)) {
			setErrors((prev) => ({
				...prev,
				phoneNumber: errorAccordingToFieldName["phoneNumber"],
			}))
		} else {
			setErrors((prev) => ({ ...prev, phoneNumber: "" }))
		}

		setFormValues((prev) => ({ ...prev, phoneNumber: value }))
	}

    const handleFieldBlur = (fieldName: string, value: string, error: string) => {
		pushToDataLayer({
			'event': 'form_filled',
			'field_name': fieldName,
			'option_selected': value || "NA",
			'error_message': error || 'NA',
			'section_name': getGlobalStateValue('parentSection'),
			'page_type': "Home Page",
			'page_url' : window?.location?.href || "NA"
		});
	};

    const handleSingleFieldChange = (
		fieldName: string,
		value: string | boolean
	) => {
		let errors = "";
		if (
			(!regexForInputs[fieldName]?.test(value) &&
				fieldName !== "degree" &&
				fieldName !== "program") ||
			value.toString().includes("Select")
		) {
			errors = errorAccordingToFieldName[fieldName];
			setErrors((prev) => ({
				...prev,
				[fieldName]: errorAccordingToFieldName[fieldName],
			}))
		} else {
			setErrors((prev) => ({ ...prev, [fieldName]: "" }))
		}
		setFormValues((prev) => ({ ...prev, [fieldName]: value }))

		if (fieldName === "countryCode") {
			handlePhoneNumberChange(formValues.phoneNumber, value.toString())
		}

		if (fieldName === "degree") {
			setFormValues((prev) => ({ ...prev, program: SELECT_PROGRAM }))
			handleFieldBlur("degree", typeof value==='string' && value, errors);
		}

        if (fieldName === "program"){
            handleFieldBlur("program", typeof value==='string' && value, errors);
        }

		if (fieldName == "program" ){
			const selectedProgram = associatedPrograms.find(
        (obj) => obj.attributes.BasicDetails?.Heading?.toLocaleUpperCase() === value
      );

      	if (selectedProgram) {
       	 specializationKey.current =
        	  selectedProgram.attributes.BasicDetails?.SpecializationText || "";
			custom10PageTypeKey.current =
					selectedProgram.attributes.BasicDetails?.Custom10PgType || "";
     	}	
			  

     	}

	}

    const leadCheckOnCompletion = async () => {
		try {
      let uniqueId = localStorage.getItem("uniqueLeadId");
          
       if (!uniqueId) {
              uniqueId = generateUniqueId();
              localStorage.setItem("uniqueLeadId", uniqueId);
            }
		  const response = await fetch("/api/leadsquared.com/lead-check", {
		  method: "POST",
		  headers: {
			"Content-Type": "application/json",
		  },
		  body: JSON.stringify({
			PhoneNo: `${formValues.countryCode}-${formValues.phoneNumber}`,
			EmailID: formValues.emailId,
			Name:formValues.fullName,
      CountryCode:formValues.countryCode,
      PageUrl:window.location.href,
      CommConsent:formatDate(new Date()),
      UniqueId: uniqueId,
			})
		  });
		
		  if (!response.ok) {
		  throw new Error("Failed to submit phone number");
		  }
		} catch (error) {
		  console.error("Error submitting phone number:", error);
		}
		};

    const checkFieldsValid = () => {
		return (
			formValues.fullName !== "" &&
			formValues.phoneNumber !== "" &&
			formValues.emailId !== "" &&
			formValues.isTermsAccepted &&
			formValues.countryCode !== CODE && 
			Object.values(errors).every((x) => x === "")
		)
	}

    const checkAllFieldsValid = () => {
		return (
			formValues.fullName.trim() !== "" &&
			formValues.phoneNumber.trim() !== "" &&
			formValues.emailId.trim() !== "" &&
			formValues.degree !== "" && 
			formValues.program !== SELECT_PROGRAM  &&
			formValues.isTermsAccepted === true &&
			formValues.countryCode !== CODE && 
			Object.values(errors).every((error) => error === "")
		);
	}

    const resetState = () => {
        setIsHeaderHidden(false)
        setIsApplicationLoader(false)
        setshowProgramField(false);
        setFormValues({
            fullName: "",
            countryCode: NATIONAL_CODE,
            phoneNumber: "",
            emailId: "",
            degree: SELECT_DEGREE,
            program: "Select Program",
            isTermsAccepted: true,
        });
        setLoadingCount(3)
    }

    const updateCountryCode = (value) => {
      const newFormValues  = { ...formValues }
      newFormValues['countryCode'] = value;
      newFormValues['phoneNumber'] = "";
      setFormValues(newFormValues);
    }
    
    const startLoader = () => { 
        setIsApplicationLoader(true);
        counterInterval.current = setInterval(() => {
            setLoadingCount((count) => {
                if (count < 1) {
                    clearInterval(counterInterval.current);
                    setTimeout(resetState, 2000);
                    if(apiResponseURL.current){
                        window.location.href = apiResponseURL.current + "&e=1"
                    }else{
                        console.error("No Response Url Found");
                    }
                    return 0;
                } else {
                    return count = count - 1;
                }
            });
        }, 1000);
    }

    const handleFormSubmit = (payload) => {
        setFormValuesData(formValues);
  
        const form = {
            name: payload.fullName,
            phone: payload.phoneNumber,
            countryCode: payload.countryCode,
            email: payload.emailId,
            program: payload.program,
            PROGRAM_ID: getProgramId({ associatedPrograms, program: payload.program, isLandingPage }),
            degree: DEGREE_TYPES[payload.degree]?.name,
            consent: true,
        };
        const tracking = trackingDetails();

        const submitCb = () => { 
            setIsHeaderHidden(true)
        };

        const verifyCb = () => { 
            setShowLoader(false);
            setFormValues({
                fullName: "",
                countryCode: "+" + ipStackDetails?.location?.calling_code || "91",
                phoneNumber: "",
                emailId: "",
                degree: SELECT_DEGREE,
                program: "",
                isTermsAccepted: true,
            })
            props?.isOtpValidated(true);
            startLoader();

        }

        const cb = () => {
            return new Promise((resolve, reject) => {
                // loading(true);
              
                const setCounselorData = async (status:boolean) => {
					try{
						const counsellorResponse = await connectCounsellorApiCall(status, form, ipStackDetails, tracking);
						const counsellorData = await counsellorResponse.json();
						return counsellorData
					}catch(err){
						console.error("Error in councelor udpate data", err)
					}
				}

                async function performApiCalls() {
                    loading(true);
                    let leadSquareResponse;
                    try {
                        const response = await leadSquareApiCall({ Custom5: "Not Verified", Custom10: custom10PageTypeKey.current || "" }, form, ipStackDetails, tracking);
                        if (typeof response === 'string') {
                            leadSquareResponse = JSON.parse(response);
                        } else {
                            leadSquareResponse = await response.json();
                        }

                        if (leadSquareResponse?.success) {
                            setIsFormValid(false);
                            const resp = leadSquareResponse?.response || {};
                            apiResponseURL.current = leadSquareResponse.response.URL || ''
                            await setCounselorData(true)
                    
                            if (resp.ID === '1' && associatedPrograms.length!==1) {

                                props.isOtpValidated(false);
                             
                                setshowProgramField(true);
                                return; // Exit here if ID is '1'
                            } 

                            if (props.setFormResponse) {
                                props.setFormResponse({
                                ID: resp?.ID,
                                link: resp?.URL,
                                ProspectId: resp?.ProspectId,
                                });
                            }

                            pushToDataLayer({
                                event: "lead_submit",
                                cta_text: "Submit",
                                lead_starting_cta: "Apply Now",
                                lead_starting_url: window.location.href || "NA",
                                lead_id: resp?.ProspectId || "NA",
                                section_name: getGlobalStateValue('parentSection'),
                                status: "success",
                                error_message: "NA",
                                page_type: "Home Page",
                                lead_type: resp.ID === '1' ? "lead_submit_1" : "lead_submit_2",
                                page_url: window?.location?.href || "NA"
                            });

                            window.webengage.user.login(resp?.ProspectId);

                            window.webengage.user.setAttribute('we_email', payload.emailId);
                            window.webengage.user.setAttribute('we_first_name', payload.fullName);
                            window.webengage.user.setAttribute('we_phone', payload.countryCode + payload.phoneNumber);                   
                            

                            window.webengage.track("Lead Form Filled", {
                                "Student Nationality": isNational ? "National" : "International",
                                "First Name": payload.fullName,
                                 "Phone Number": payload.countryCode + payload.phoneNumber,
                                 "Email ID": payload.emailId,
                                 "Form Type": "Apply",
                                 "Section Name": getGlobalStateValue('parentSection'),
                                 "Application URL": resp?.URL || "",
                                });


                            if (typeof setLeadResponse === "function") {
                                setLeadResponse(resp);
                            }
                            setIsHeaderHidden(true);
                            props.setMessage(
                                `Your request for counselling has been sent ${leadSquareResponse?.isDuplicate ? "already" : ""
                                }, and our counsellor will reach out to you in the next few hours.`
                            );

                            if(payload?.countryCode !== NATIONAL_CODE){
                                startLoader();
                                props?.isOtpValidated(true, resp?.ProspectId);
                            }
                        }else{
                            setShowLoader(false);
                            setIsFormValid(false);
							const counselorApiData = await setCounselorData(false)
							setshowProgramField(true);
							return;
                        }
                        resolve(leadSquareResponse?.response);
                    } catch (error) {
                        pushToDataLayer({
                            event  : "lead_submit",
                            cta_text : "Submit",
                            lead_starting_cta : "Apply Now",
                            lead_starting_url : window.location.href || "NA",
                            lead_id : "NA",
                            section_name : getGlobalStateValue('parentSection'),
                            status : "fail",
                            error_message : error || "NA",
                            page_type : getGlobalStateValue('pageType'),
                            lead_type : "lead_submit_1",
                            page_url : window?.location?.href || "NA"
                        });
                        console.error("LeadSquare API call failed:", error);
                        setIsFormValid(false);
                        const counselorApiData = await setCounselorData(false)
                        setshowProgramField(true);
                        setMessage(error);
						reject(error);
                        return;
                    } finally {
						loading(false);						
					}
                    
                }

                performApiCalls();
            })
        }
        handleSendOTP(form, cb, submitCb, verifyCb, checkLeadFail)
    }

    function extractDegree(program) {
		const match = program.match(/(PG|UG)_Program/);
		return match ? match[1] : null;
	}

	const makeFormSubmission = useCallback(
		(e: any) => {
			e.preventDefault()
			const valid = checkFieldsValid()
			const isValid = checkAllFieldsValid()

            if ( associatedPrograms.length === 1 ) {
                const programDegree = associatedPrograms[0].attributes.BasicDetails.ProgramType;
                const programTitle = associatedPrograms[0].attributes.BasicDetails.Heading;
                specializationKey.current =
                associatedPrograms[0].attributes.BasicDetails?.SpecializationText || "";
              custom10PageTypeKey.current =
                      associatedPrograms[0].attributes.BasicDetails?.Custom10PgType || "";
                    handleSingleFieldChange("degree", extractDegree(programDegree));
                    handleSingleFieldChange("program", programTitle);
                    const updatedValues = {
                        ...formValues,
                        degree: extractDegree(programDegree),
                        program: programTitle,
                    };
                    handleFormSubmit(updatedValues);
                    return;
                }
		
			if(isNewLeadForm){
				if(!showProgramField && valid ){
					handleFormSubmit(formValues)
				} else if (isValid){
					handleFormSubmit(formValues);
				}
			} else {
				isValid && handleFormSubmit(formValues);
			}
		},
		[formValues, isNewLeadForm, showProgramField]
	)

	useEffect(() => {
     fetchIpInfoFunNew({ setIpStackDetails, setFormValues });
	}, [])

     useEffect(() => {
        let isValid = false;
      
        if (formValues.countryCode === '+91') {
          isValid = regexForInputs["phoneNumber"].test(formValues.phoneNumber);
        } else {
          const regexToUse = /^[1-9][0-9]{6,14}$/
          isValid = regexToUse.test(formValues.phoneNumber);
        }
      
        if (isValid) {
          const handler = setTimeout(() => {
            leadCheckOnCompletion();
          }, 2000);
      
          return () => {
            clearTimeout(handler);
          };
        }
      }, [formValues.phoneNumber, formValues.countryCode]);
    
    
      useEffect(() => {
        let isValid = false;
    
        if (regexForInputs["emailId"].test(formValues.emailId) ) {
            isValid=true;
        }
      
        if (isValid) {
          const handler = setTimeout(() => {
            leadCheckOnCompletion();
          }, 2000);
      
          return () => {
            clearTimeout(handler);
          };
        }
      }, [formValues.emailId]);

    useEffect(() => {
        const list = PROGRAM_DROPDOWN.filter(
            (x: any) => x.programType == formValues?.degree
        ).map((x: any) => x.title)

        let finalProgramsList = list?.length ? list : programsOptions

        if (ipStackDetails?.country_code !== "IN") {
            finalProgramsList = finalProgramsList.filter(
                (x: any) => !excludeProgramsOutsideIndia.includes(x)
            )
        }
        setProgramsList(finalProgramsList)
	}, [formValues?.degree, ipStackDetails])

    useEffect(() => {
		if(isNewLeadForm){
		if(!showProgramField){
		const isFormValid = checkFieldsValid()
		setIsFormValid(isFormValid)
		} else if(showProgramField){
			const isFormValid =  checkAllFieldsValid()
	        setIsFormValid(isFormValid)
		}
	} else {
		   const isFormValid =  checkAllFieldsValid()
	        setIsFormValid(isFormValid);
	}
	}, [formValues, setIsFormValid])
    
    
    return (
        <>
        {isApplicationLoader ? (
          <ApplicationFormRedirectLoader redirectTime={loadingCount} isDarkForm={true} />
        ) : (
          <form onSubmit={makeFormSubmission} className={cn(styles.root)}>
            {/* name */}
            <div className={cn(styles.inputWrapper)}>
                <label htmlFor="input">full name *</label>
                <Input
                  isDark={true}
                  placeholder="Enter your full name"
                  value={formValues.fullName}
                  onChangeFunc={(value: string) => handleSingleFieldChange("fullName", value)}
                  onBlur={() => handleFieldBlur("fullName", "", errors.fullName)}
                />
                <p className={cn(styles.error)}>{errors.fullName}</p>
            </div>
            {/* phone with code */}
            <div className={cn(styles.inputWrapper)}>
                <label htmlFor="input">phone number *</label>
                <div className="flex gap-[6px]">
                  <div> 
                <CountryDropdownGlobal
                onChangeFunc={(value: string) => handleSingleFieldChange("countryCode", value)}
                countries={ALL_COUNTRIES}
                countryCode={formValues.countryCode}
                updateCountryCode={updateCountryCode}
                additionalStyle="h-[2.25rem]"
                isDark={true}
              />
                  </div>
                  <div className="w-full">
                    <Input
                        isDark={true}
                      placeholder="Enter your no."
                      value={formValues.phoneNumber}
                      onChangeFunc={handlePhoneNumberChange}
                      onBlur={() => handleFieldBlur("phoneNumber", "", errors.phoneNumber)}
                    />
                  </div>
                </div>
                <p className={cn(styles.error)}>{errors.countryCode || errors.phoneNumber}</p>
              </div>
              {/* Email */}
            <div className={cn(styles.inputWrapper)}>
                <label htmlFor="input">email id *</label>
                <Input
                isDark={true}
                  placeholder="abc@xyz.com"
                  value={formValues.emailId}
                  onChangeFunc={(value: string) => handleSingleFieldChange("emailId", value)}
                  onBlur={() => handleFieldBlur("emailId", "", errors.emailId)}
                />
                <p className={cn(styles.error)}>{errors.emailId}</p>
            </div>
            {/* Degree */}
            {showProgramField && (
            <div className={cn(styles.inputWrapper)}>
                <label>Degree you are looking for *</label>
                <SelectDark
                value={formValues.degree}
                onChangeFunc={(value: string) => {
                    handleSingleFieldChange("degree", value);
                }}
                options={[SELECT_DEGREE, ...degreeOptions]}
                />
                <p className={cn(styles.error)}>{errors.degree}</p>
            </div>
            )}
            {/* Program */}
            {showProgramField &&
                (<div className={cn(styles.commonMargins, "w-full")}>
                    <label>Programs you are looking for *</label>
                    <SelectDark
                        value={formValues.program}
                        onChangeFunc={(value: string) => {
                        handleSingleFieldChange("program", value);
                        }}
                        options={["Select Program", ...programsList]}
                    />
                    <p className={cn(styles.error)}>{errors.program}</p>
                </div>)
            }
            <div className={cn(styles.commonMargins, "flex items-start gap-[17px]")}>
              <div className="shrink-0">
                <Checkbox
                isDark={true}
                  name="consent"
                  value={formValues.isTermsAccepted}
                  onChangeFunc={(value: boolean) => handleSingleFieldChange("isTermsAccepted", value)}
                  onBlur={() => handleFieldBlur("isTermsAccepted", "", errors.isTermsAccepted)}
                />
              </div>
              <p className={cn(styles.authorization)}>
               <ConsentFormPara/>
              </p>
            </div>
            <SubmitButton
            bgColor="#ffc907"
            textColor="#1a325d"
              text={isLoading || isOTPLoading ? "Submitting" : "Submit"}
              isDisabled={isLoading || isOTPLoading || !isFormValid}
            />
          </form>
        )}
        </>
          );
 }

 export default HomeConnectModalForm;

 
